import { shouldShowTeacherPortal } from "../../../../redux/bridge/selectors";
import { getIsbns } from "../../../../redux/books/selectors";
import { connect } from "react-redux";
import TeacherFooter from "./teacher-footer";
import DefaultFooter from "./default-footer";
import React from "react";

function Footer({ isbns, showTeacherFooter, ...footerProps }) {
	// footers need to respect incoming "offset" prop
	if (showTeacherFooter) {
		return <TeacherFooter isbns={isbns} {...footerProps} />;
	}

	return <DefaultFooter isbns={isbns} {...footerProps} />;
}

export default connect(state => ({
	showTeacherFooter: shouldShowTeacherPortal(state),
	isbns: getIsbns(state)
}))(Footer);
